<template>
	<div class="table">
		<el-table
			border
			ref="multipleTable"
			id="peopleTable"
			:data="tableData"
			:header-cell-style="{ 'text-align': 'center' }"
			height="340px"
			:cell-style="{ 'text-align': 'center' }"
			tooltip-effect="dark"
			style="width: 100%"
		>
			<el-table-column prop="userName" label="操作人员" width="80px">
			</el-table-column>
			<el-table-column prop="message" label="行为"> </el-table-column>
			<el-table-column prop="time" label="时间" width="140px">
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
export default {
	props: ["tableData"],
	name: "",
	data() {
		return {
			value: true,
		};
	},
	methods: {},
};
</script>

<style scoped></style>
